import { ROUTES } from '#/config/routes';

/** 倉儲 hub 導覽卡 */
const warehouseNavigate = [
  {
    to: ROUTES.inventoryStock,
    title: '庫存',
    subtitle: '查詢庫存批次與儲位',
  },
  {
    to: ROUTES.inventorySafetyCheck,
    title: '安全庫存',
    subtitle: '低於安全量的物料',
  },
  {
    to: ROUTES.materialMgmt,
    title: '物料管理',
    subtitle: '物料主檔、規格、模板與結構',
  },
  {
    to: ROUTES.documentMgmt,
    title: '單據管理',
    subtitle: '入庫等庫存單據',
  },
  {
    to: ROUTES.storePlaceMgmt,
    title: '倉別管理',
    subtitle: '倉別主檔與儲位設定',
  },
];

export default warehouseNavigate;
